import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { ResponsiveContainer } from "recharts";
import FormDialog from "./FormDialog";
import moment from "moment";
import LinearBuffer from "./LinearBuffer";
import {
  // NotificationManager,
  NotificationContainer,
} from "react-notifications";
// import { httpClient } from "appUtility/Api";

// const qs = require("qs");
// const loginData = JSON.parse(window.localStorage.getItem("login"));

const BasicTable = (props) => {
  //--- Destructure isLoading from props ---//
  const { recentCalls, isLoading } = props;

  return (
    <>
      <ResponsiveContainer>
        <div className="table-responsive-material">
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>SN</TableCell> */}
                <TableCell align="left">Reference No.</TableCell>
                <TableCell align="left">Added Date/Time</TableCell>
                <TableCell align="left">Customer</TableCell>
                <TableCell align="left">Address</TableCell>
                <TableCell align="left">Suburb</TableCell>
                <TableCell align="left">Phone</TableCell>
                <TableCell align="left">Call Type</TableCell>
                <TableCell align="left">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/*--- Updated rendering logic ---*/}
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <LinearBuffer />
                  </TableCell>
                </TableRow>
              ) : recentCalls && recentCalls.length > 0 ? (
                recentCalls.map((n, index) => {
                  return (
                    <TableRow key={index}>
                      {/* ... (rest of your TableCell code) ... */}
                      <TableCell align="left">{n.referenceNumber}</TableCell>
                      <TableCell align="left">
                        {moment(n.addedDate + " " + n.addedTime).format(
                          "Do MMM, h:mm a"
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {n.firstName} {n.lastName}
                      </TableCell>
                      <TableCell align="left">{n.address}</TableCell>
                      <TableCell align="left">{n.suburb}</TableCell>
                      <TableCell align="left">{n.phone}</TableCell>
                      <TableCell align="left" style={{ color: "#b5b5b5" }}>
                        {n.messageType}
                      </TableCell>
                      <TableCell align="left">
                        {
                          <>
                            <FormDialog
                              rowID={n.logID}
                              rowDate={n.addedDate}
                              rowTime={n.addedTime}
                              rowPhone={n.phone}
                              rowPhone2={n.phone2}
                              rowSuburb={n.suburb}
                              rowFirstName={n.firstName}
                              rowLastName={n.lastName}
                              rowAddress={n.address}
                              rowPetName={n.petName}
                              rowPetBreed={n.petBreed}
                              rowPetGender={n.gender}
                              interestedService={n.interestedService}
                              messageType={n.messageType}
                              rowEmail={n.email}
                              notes={n.notes}
                              leadNotes={n.leadNotes}
                              commentText={n.commentText || n.message}
                              reschedule={n.reschedule}
                              addedBy={n.addedBy}
                              referredby={n.referredby}
                              franchiseeName={n.franchiseeName}
                              referenceNumber={n.referenceNumber}
                              organization={n.organization}
                              postCode={n.service_area_postcode}
                              callScenario={n.callScenario}
                            />
                          </>
                        }
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <h2 style={{ marginTop: "2%", marginLeft: "2%" }}>
                      {recentCalls === null
                        ? "Sorry, data not available right now..."
                        : "No Recent Calls Found"}
                    </h2>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <NotificationContainer />
        </div>
      </ResponsiveContainer>
    </>
  );
};

export default BasicTable;
